import * as Types from '../constants/Types';

export const dataVinWonderAction = (filters) => ({ type: Types.VIN_WONDER_LIST_ACTION, filters });
export const dataVinWonderSuccess = (vinWonders) => ({ type: Types.VIN_WONDER_LIST_SUCCESS, vinWonders });

export const createVinWonderAction = (params) => ({ type: Types.VIN_WONDER_CREATE_ACTION, params });
export const deleteVinWonderAction = (params) => ({ type: Types.VIN_WONDER_DELETE_ACTION, params });

export const getUpdateVinWonderAction = (params) => ({ type: Types.VIN_WONDER_GET_UPDATE_ACTION, params });
export const getUpdateVinWonderSuccess = (vinWonder) => ({ type: Types.VIN_WONDER_GET_UPDATE_SUCCESS, vinWonder });
export const updateVinWonderAction = (params) => ({ type: Types.VIN_WONDER_UPDATE_ACTION, params });

export const createVinWonderTranslate = (vinWonder) => ({ type: Types.VIN_WONDER_CREATE_TRANSLATE_ACTION, vinWonder });
export const updateVinWonderTranslate = (vinWonder) => ({ type: Types.VIN_WONDER_UPDATE_TRANSLATE_ACTION, vinWonder });
export const deleteVinWonderTranslate = (vinWonder, refreshParams) => ({ type: Types.VIN_WONDER_DELETE_TRANSLATE_ACTION, vinWonder, refreshParams });

export const resetVinWonder = () => ({ type: Types.VIN_WONDER_RESET });

export const checkVinWonderAction = (serialNumber) => ({ type: Types.VIN_WONDER_CHECK_ACTION, serialNumber });
export const checkVinWonderSuccess = (resultCheck) => ({ type: Types.VIN_WONDER_CHECK_SUCCESS, resultCheck });
export const checkVinWonderFailAction = (params) => ({ type: Types.VIN_WONDER_CHECK_FAIL, params });
export const vinWonderReset = () => ({ type: Types.VIN_WONDER_RESET });

export const vinWonderSitesAction = () => ({ type: Types.VIN_WONDER_SITES_ACTION });
export const vinWonderSitesSuccess = (vinWonderSites) => ({ type: Types.VIN_WONDER_SITES_SUCCESS, vinWonderSites });

export const vinWonderTypesAction = () => ({ type: Types.VIN_WONDER_TYPES_ACTION });
export const vinWonderTypesSuccess = (vinWonderTypes) => ({ type: Types.VIN_WONDER_TYPES_SUCCESS, vinWonderTypes });

export const vinWonderSessionAction = (params) => ({ type: Types.VIN_WONDER_SESSION_ACTION, params });
export const vinWonderSessionSuccess = (vinWonderSession) => ({ type: Types.VIN_WONDER_SESSION_SUCCESS, vinWonderSession });

export const vinWonderZoneAction = (params) => ({ type: Types.VIN_WONDER_ZONE_ACTION, params });
export const vinWonderZoneSuccess = (vinWonderZone) => ({ type: Types.VIN_WONDER_ZONE_SUCCESS, vinWonderZone });